import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import {
  TellentAdoptedStylesheetsDirective,
  TellentSampleDataBannerInfoComponent,
} from '@core/tellent-smart-ui';
import type { InputSignalLike, TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-sample-data-banner-info',
  template: `
    <tlc-sample-data-banner-info
      [messagePrefix]="messagePrefix()"
      [ctaLabel]="ctaLabel()"
      [messageSuffix]="messageSuffix()"
      (ctaClick)="ctaClick.emit()"
    />
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: contents;
      color: inherit !important;
    }
  `,
  hostDirectives: [TellentAdoptedStylesheetsDirective],
  imports: [TellentSampleDataBannerInfoComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentSampleDataBannerInfoWrapComponent {
  public messagePrefix: InputSignalLike<string> = input('');
  public ctaLabel: InputSignalLike<string> = input('');
  public messageSuffix: InputSignalLike<string> = input('');

  public ctaClick = output<void>();
}

export type TellentSampleDataBannerInfoWebComponent = TellentWebComponent<
  TellentSampleDataBannerInfoWrapComponent,
  'messagePrefix' | 'ctaLabel' | 'messageSuffix' | 'ctaClick'
>;
